function initializeMilitarshopArticles(root = document) {
  root.querySelectorAll('[data-ms-blog-article]').forEach(article => {
    if (article.dataset.tocReady) return;
    article.dataset.tocReady = 'true';
    const content = article.querySelector('[data-ms-blog-content]');
    if (!content) return;
    content.querySelectorAll('table').forEach(table => {
      if (table.closest('.ms-blog-table')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'ms-blog-table';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.append(table);
    });
    const headings = [...content.querySelectorAll('h2')];
    const toc = article.querySelector('[data-ms-blog-toc]');
    if (!headings.length) return;
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `article-${index + 1}`;
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      toc.append(link);
    });
    article.querySelector('.ms-blog-toc').hidden = false;
    const details = toc.closest('details');
    const media = window.matchMedia('(min-width: 1024px)');
    const sync = () => { details.open = media.matches; };
    sync();
    media.addEventListener('change', sync);
    toc.addEventListener('click', event => {
      if (event.target.closest('a') && !media.matches) details.open = false;
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        toc.querySelectorAll('a').forEach(link => {
          if (link.hash === `#${entry.target.id}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      });
    }, { rootMargin: '-20% 0px -65% 0px' });
    headings.forEach(heading => observer.observe(heading));
  });
}
initializeMilitarshopArticles();
document.addEventListener('shopify:section:load', event => initializeMilitarshopArticles(event.target));
